
// Redundant openclick function removed
class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');

        var flag = $('.cart-timer [data-duration]').data('flag');
        if (flag == "1") {
            $('.cart-timer [data-duration]').data('flag', "0");
            setInterval(function () {
                var timer2 = $('.cart-timer [data-duration]').data('duration');
                var timer = parseInt(timer2);
                var minutes = parseInt(timer[0], 10);
                var seconds = parseInt(timer[1], 10);
                --timer;
                if (timer < 1) {
                    timer = 90;
                }
                $('.cart-timer [data-duration]').data('duration', timer);
                minutes = ~~(timer / 60)
                seconds = ~~(timer % 60)
                $('.cart-timer [data-duration]').html('<span>0' + minutes + '</span>:<span>' + (9 < seconds ? '' : '0') + seconds + '</span>');
            }, 1000);
        }
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
        const itemCount = (parsedState.item_count !== undefined) ? parsedState.item_count : (parsedState.items ? parsedState.items.length : 1);

        if (itemCount > 0) {
            this.classList.remove('is-empty');
            const inner = this.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
        } else {
            this.classList.add('is-empty');
            const inner = this.querySelector('.drawer__inner');
            if (inner) inner.classList.add('is-empty');
        }
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            if (itemCount > 0) {
                this.open();
            } else {
                this.close();
            }
        });

        // Redundant call removed




        const cartItems = this.querySelectorAll(".cart-item");
        let found = false;

        cartItems.forEach(function (item) {
            if (found) return;

            const attrib = item.getAttribute("data-sellingplan");

            if (attrib) {
                const upsellBtns = document.querySelectorAll(".upsell-product-btn button");

                upsellBtns.forEach(function (btn) {
                    const upsellPlan = btn.getAttribute("data-sellingplan");

                    const existingInput = btn.parentElement.querySelector(".sellingplancart");
                    if (existingInput) existingInput.remove(); // Always clear first

                    if (upsellPlan) {
                        const hiddenInput = document.createElement("input");
                        hiddenInput.type = "hidden";
                        hiddenInput.className = "sellingplancart";
                        hiddenInput.name = "selling_plan";
                        hiddenInput.value = upsellPlan;

                        btn.parentElement.insertBefore(hiddenInput, btn);
                    }
                });
                var shipping_protection = document.querySelector("#privacy_protection_input");
                if (shipping_protection) {
                    shipping_protection.setAttribute("data-selling", "12512690340");
                }
                found = true;
            } else {


                const upsellBtns = document.querySelectorAll(".upsell-product-btn button");

                upsellBtns.forEach(function (btn) {
                    const existingInput = btn.parentElement.querySelector(".sellingplancart");
                    if (existingInput) existingInput.remove();
                });
                var shipping_protection = document.querySelector("#privacy_protection_input");
                if (shipping_protection) {
                    shipping_protection.setAttribute("data-selling", "false");
                }
                console.log("No selling plan on this cart item — upsell selling plans removed.");


            }


        });


        if (typeof updateConvertedAttributec === 'function') {
            document.querySelectorAll(".cart-item__old-price.product-option").forEach(updateConvertedAttributec);
        }
        if (typeof syncWelcomeGift === 'function') syncWelcomeGift();
        // product-form.js publishes cartUpdate BEFORE this method swaps in the new drawer HTML, so
        // the savings listener runs against the old DOM. Recalculate now that the markup is live.
        if (typeof updateSavingsUI === 'function') updateSavingsUI();

    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);
